var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"c-info-wrapper border py-2 px-3",class:_setup.computedClass},[(!_setup.slots.default)?[(_vm.icon)?_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }